angular.module("Main").controller("Step2KursbuchungController", ["$rootScope", "$scope", "$sce", "$state", "$stateParams",
    "$localStorage", "$window", "$uibModal", "$translate", "BookingService",
    "PaymentService", "SessionService", "AuthenticationService", "DialogService",
    function ($rootScope, $scope, $sce, $state, $stateParams, $localStorage, $window, $uibModal, $translate, BookingService,
              PaymentService, SessionService, AuthenticationService, DialogService) {
        var vm = this;

        vm.isLoggedIn = $stateParams.isLoggedIn;
        vm.optionButton = '0';
        vm.text = {};
        vm.hasBlockkurse = false;
        vm.accepted = false;
        vm.showPayments = false;
        vm.choosenPaymentMethod = null;
        vm.reservationError = false;
        vm.spinner = false;
        vm.ageLimit = false;

        if (screen.width < 600) {
            vm.isMobilePhone = true;
            vm.weekView = true
        } else {
            vm.isMobilePhone = false;
            vm.weekView = true;
        }

        getKursbuchungLayouKonfiguration();
        loadConfigs();
        checkIfSixPaymentConfig();

        function checkIfSixPaymentConfig() {
            BookingService.checkSixConfig().then(function (data) {
                vm.isSixPayment = data.paymentValid;
            })
        }

        function checkTerminartPayments() {
            BookingService.checkPayments(vm.cookies.kursData.kurs.Terminart_Nr).then(function (data) {
                vm.terminartPayments = data;
            })
        }

        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkUser();
            init();
            vm.isLoggedIn = data;
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        if (!SessionService.getSessionId()) {
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else {
            loadConfigs()
            start();
        }

        function start() {
            vm.cookies = SessionService.checkSession();
            if (_.isNil(vm.cookies.kursData)) {
                unregisterEventHandler();
                $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
            }
            var now = new Date();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.now = new Date();
            checkUser();
            checkTerminartPayments();
            init();
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            })
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.privacytermsText = data.PrivacyPolicy;
                vm.layoutSettings.MRVerbergenKB = data.MRVerbergenKB;
                vm.layoutSettings.NMRVerbergenKB = data.NMRVerbergenKB;
                vm.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
            });
        }

        $('#register-focus').autofocus;

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });
            BookingService.checkBarzahlungEndpoint().then(function () {
                vm.checkBarZahlungEndpointFailed = false;
            }).catch(function (error) {
                vm.checkBarZahlungEndpointFailed = true;

            });
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('angebot', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
                }
            }
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;

        }

        vm.registerFinish = false;
        vm.booking = {};

        function init() {
            if (_.isNil(vm.cookies.kursData)) {
                unregisterEventHandler();
                $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
            } else {
                vm.onlyMitarbeiter = false;
                let mitarbeiter = _.sortBy(_.filter(vm.cookies.kursData.kurs.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                let nichtMitarbeiter = _.sortBy(_.filter(vm.cookies.kursData.kurs.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                if (nichtMitarbeiter.length === 0 || _.isUndefined(nichtMitarbeiter) || nichtMitarbeiter === null || !nichtMitarbeiter) {
                    vm.onlyMitarbeiter = true;
                }
                let ress = _.concat(mitarbeiter, nichtMitarbeiter);
                vm.ressources = _.join(_.map(ress, "Bezeichnung"), " ,");

                // BookingService.getResourceNamesKB(vm.cookies.kursData.kurs.AllRessources, vm.cookies.kursData.kurs.Terminart_Nr).then(function (names) {
                //     vm.MitarbeiterRessource = _.join(_.map(_.sortBy(_.filter(names, {Mitarbeiter: 1}), 'Bezeichnung'), "Bezeichnung"), " ,");
                //     vm.NichtMitarbeiterRessource = _.sortBy(_.filter(names, {Mitarbeiter: 0}), 'Bezeichnung');
                // });
                if (!vm.isLoggedIn) {
                    vm.choosenRegistration = true;
                } else {
                    if(vm.cookies.kursData.kurs.BuchungslimitMitgliedZulassen) {
                        BookingService.checkAppointmentMemberLimit(vm.currentUser.memberNr, vm.cookies.kursData.kurs.completeStart, vm.cookies.kursData.kurs.completeEnde).then(function (limit) {
                            if (limit.Count > 0){
                                vm.limitMember = limit;
                            }
                        }).catch(function () {
                        });
                    }
                    if(vm.cookies.kursData.kurs.Altersbeschraenkung > 0) {
                        BookingService.checkAltersbeschraenkung(vm.currentUser.memberNr, vm.cookies.kursData.kurs.Terminart_Nr, vm.cookies.kursData.kurs.completeStart).then(function (age) {
                            if (age.Limit){
                                vm.ageLimit = true;
                            }
                        }).catch(function () {
                        });
                    }
                    BookingService.checkAppointmentGroupLimit(vm.cookies.kursData.kurs.Terminart_Nr,
                        vm.currentUser.memberNr, vm.cookies.kursData.kurs.completeStart).then(function (limits) {
                        if (limits && ((limits.day && limits.day.reached) || (limits.week && limits.week.reached) ||
                                (limits.month && limits.month.reached) || (limits.year && limits.year.reached))) {
                            vm.limits = limits;
                        }
                    }).catch(function () {
                    });

                    if (vm.cookies.kursData.kurs.Bezahlung === 3) {
                        PaymentService.getArticlePrice(vm.currentUser.uid, vm.cookies.kursData.kurs.Terminart_Nr, vm.cookies.kursData.kurs.completeStart)
                            .then(function (priceData) {
                                if (!_.isEmpty(priceData))
                                    vm.cookies.kursData.kurs.PreisZahl = priceData.Price;
                            }).catch(function () {
                        });
                    }
                }
                if (vm.cookies.kursData.kurs.SerienterminNr > 0 && vm.cookies.kursData.kurs.IstBlockkurs) {
                    BookingService.getBlockkursTermine(vm.cookies.kursData.kurs.SerienterminNr).then(function (data) {
                        vm.hasBlockkurse = true;
                        vm.kurs.Blockkurs = data;
                        _.forEach(data, function (d) {
                            d.Tag = new Date(d.Start);
                            d.Tag = moment(d.Tag).format('YYYY-MM-DD').toString();
                            d.Start = moment(d.Start).format('HH:mm').toString();
                            d.Ende = moment(d.Ende).format('HH:mm').toString();
                        });
                    })
                }
                vm.kurs = vm.cookies.kursData.kurs;
                //vm.infotext = $sce.trustAsHtml(vm.kurs.Infotext).toString()

                BookingService.getImage(vm.kurs.Terminart_Nr).then(function (data) {
                    vm.kurs.Image = data;
                });
                BookingService.loadConfigurationStammdaten().then(function (texts) {
                    vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
                    if (texts.TextObligatory) {
                        vm.text.vb = "T_verpflichtend_buchen";
                        vm.text.vbe = "T_kostenpflichtig_buchen";
                        vm.text.mvb = "T_verpflichtend_buchen";
                        vm.text.mvbe = "T_kostenpflichtig_buchen";
                    } else {
                        vm.text.vb = "T_Buchen";
                        vm.text.vbe = "T_Bezahlen";
                        vm.text.mvb = "T_Buchen";
                        vm.text.mvbe = "T_Bezahlen";
                    }
                });
            }
        }

        // vm.bookAsLoggedIn = function () {
        //     if (vm.kurs.IstBlockkurs) {
        //         startPaymentBlockkurs();
        //     } else
        //         startPayment();
        // };

        vm.bookAsLoggedInVorOrt = function (method) {
            if (vm.spinner) return;
            vm.spinner = true;
            init();
            if (vm.kurs.IstBlockkurs) {
                bookWithoutPaymentBlockkurs(method);
            } else
                bookWithoutPayment(method);
        };

        vm.setOnWaitlist = function () {
            if (vm.kurs.IstBlockkurs) {
                setOnWaitlistBlockkurs()
            } else
                setOnWaitlistKurs()
        };

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.loginModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.hideLogin = true;
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        /*vm.registerAndBook = function (registration) {
            vm.dataForm.salutation.$setTouched();
            vm.dataForm.firstname.$setTouched();
            vm.dataForm.lastname.$setTouched();
            vm.dataForm.email.$setTouched();
            vm.dataForm.street.$setTouched();
            vm.dataForm.zip.$setTouched();
            vm.dataForm.city.$setTouched();
            vm.dataForm.phone.$setTouched();
            vm.dataForm.mobile_nr.$setTouched();
            vm.dataForm.password.$setTouched();
            vm.dataForm.privacyterms.$setTouched();
            if (vm.dataForm.$valid) {
                registration.mobile_nr = validator.whitelist(registration.mobile_nr, "+1234567890");
                BookingService.findUser(registration.firstname, registration.email).then(function (data) {
                    if (data.IsRegistered) {
                        vm.alreadyRegistered = true;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Loggen_sie_sich_ein";
                    } else {
                        if (!_.isEmpty(data.uid))
                            registration.PersonNr = data.uid;
                        BookingService.createTemporaryMember(registration).then(function (temporaryMember) {
                            return BookingService.sendRegistrationEmail(registration.email, temporaryMember);
                        }).then(function () {
                            vm.registerFinish = true;
                            vm.errorText = "LT_Es_wurde_email_geschickt";
                        }).catch(function () {
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                        });
                    }
                }).catch(function (err) {
                    vm.errorHeader = "T_Fehler";
                    vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                })
            }
        };*/


        vm.chooseLoginButton = function () {
            vm.choosenRegistration = false;
            // reset login status
            SessionService.clear("globals");
            vm.dataForm = {};
            vm.loginData = {};
            vm.isMember = false;
            vm.openFormForgotPassword = false;
            vm.wrongLoginData = false;
            vm.openFormChangePassword = false;
        };

        vm.chooseRegistrierungButton = function () {
            vm.choosenRegistration = true;
        };


        vm.login = function (email, password) {
            vm.dataForm.password.$setTouched();
            vm.dataForm.email.$setTouched();
            if (vm.dataForm.$valid) {
                AuthenticationService.login(email, password).then(function (data) {
                    if (!_.isNil(data)) {
                        vm.isLoggedIn = true;
                        vm.username = data.Firstname + " " + data.Lastname;
                        $rootScope.$emit("login", vm.isLoggedIn);
                    } else {
                        vm.wrongLoginData = true;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Falsche_Logindaten";
                    }
                });
            }
        };

        vm.openForgotPassword = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.openChangePassword = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/changePassword.html",
                controller: "ChangePasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.registerModal = function () {
            DialogService.openRegisterDialog(vm.kurs.PreisZahl).then(function (data) {
                if (!_.isNil(data) && _.isUndefined($localStorage.user)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                } else {
                    let now = new Date;
                    let hours = 6;
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        vm.loginResgister = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.hideLogin = true;
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        function bookPayPal() {
            if (vm.spinner) return;

            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                LinkId: $stateParams.id,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse
            };
            vm.spinner = true;
            PaymentService.startKursPayPal(tempBooking).then(function (url) {
                unregisterEventHandler();
                vm.spinner = false;
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 489) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true,
                        isTermin: false,
                        message: error.data.message,
                        start: error.data.start,
                        ende: error.data.ende,
                        name: error.data.name
                    });
                }
                if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    }
                }
                else if (error.status === 488) {
                    unregisterEventHandler();
                    vm.reservationError = true
                }
                else if (error.status === 500) {
                    unregisterEventHandler();
                    $state.go("payment_pp_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true,
                        isTermin: false,
                        oid: $stateParams.oid
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("payment_pp_fail_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        message: error.data.message,
                        isKurs: true,
                        isTermin: false,
                    });
                }
            })
        }

        function bookPayPalBlockkurs() {
            if (vm.spinner) return;

            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                LinkId: $stateParams.id,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse
            };
            vm.spinner = true;
            PaymentService.startPayPalBlockkurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                vm.spinner = false;
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 489) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true,
                        isTermin: false,
                        message: error.data.message,
                        start: error.data.start,
                        ende: error.data.ende,
                        name: error.data.name
                    });
                }
                else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    }
                }
                else if (error.status === 488) {
                    unregisterEventHandler();
                    vm.reservationError = true;
                }
                else if (error.status === 500) {
                    unregisterEventHandler();
                    $state.go("payment_pp_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("payment_pp_fail_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        message: error.data.message,
                        isKurs: true
                    });
                }
            });
        }


        function bookSix() {
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                LinkId: $stateParams.id,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse
            };
            vm.spinner = true;
            PaymentService.startPaymentKurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                vm.spinner = false;
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 410) {
                    unregisterEventHandler();
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false
                    });
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    } else if (error.data !== "LT_CANT_BOOK_NUTZUNGSRECHTE" && error.data !== "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("payment_member_already", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            message: error.data.message,
                            start: error.data.start,
                            ende: error.data.ende,
                            name: error.data.name
                        });
                    }
                } else {
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false
                    });
                }
            });
        }

        function bookSixBlockkurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                LinkId: $stateParams.id,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse
            };
            vm.spinner = true
            PaymentService.startPaymentBlockkurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                vm.spinner = false;
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    } else if (error.data !== "LT_CANT_BOOK_NUTZUNGSRECHTE" && error.data !== "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("payment_member_already", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            message: error.data.message,
                            start: error.data.start,
                            ende: error.data.ende,
                            name: error.data.name
                        });
                    }
                } else {
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                }
            });
        }

        function bookWithoutPaymentBlockkurs(method) {
            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                Zahlart: _.upperCase(method),
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse
            };
            vm.spinner = true;
            BookingService.createBookingBlockkurs(tempBooking).then(function (data) {
                vm.spinner = false;
                unregisterEventHandler();
                $state.go('booking_success_kurs', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    oid: data.oid,
                    bNr: data.bNr,
                    isKurs: true,
                    isBlock: true
                });
            }).catch(function (error) {
                vm.spinner = false;
                let orderId = (_.isNil(error.data.orderId)) ? null : error.data.orderId;
                BookingService.saveAppointmentBookingFailedHistory(error, vm.kurs.Nr, userData.uid,  'Step2KursbuchungController');
                if(orderId) {
                    BookingService.deleteMemberFromAppointment(orderId);
                }
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_TOO_LONG_COURSE") {
                        $state.go("tooLongCours", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_TOO_LONG_COURSE"
                        });
                    } else if (error.data !== "LT_CANT_BOOK_NUTZUNGSRECHTE" && error.data !== "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("payment_member_already", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            message: error.data.message,
                            start: error.data.start,
                            ende: error.data.ende,
                            name: error.data.name
                        });
                    }
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                }
            })
        }

        function bookWithoutPayment(method) {

            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                Zahlart: _.upperCase(method),
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse
            };
            vm.spinner = true;
            BookingService.createBookingKurs(tempBooking).then(function (orderId) {
                unregisterEventHandler();
                vm.spinner = false;
                $state.go('booking_success_kurs', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    oid: orderId,
                    isKurs: true,
                    isTermin: false,
                });
            }).catch(function (error) {
                vm.spinner = false;
                let orderId = (_.isNil(error.data.orderId)) ? null : error.data.orderId;
                BookingService.saveAppointmentBookingFailedHistory(error, vm.kurs.Nr, userData.uid,  'Step2KursbuchungController');
                if(orderId) {
                    BookingService.deleteMemberFromAppointment(orderId);
                }
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                        if(error.data === "LT_CANT_BOOK_TOO_LONG_COURSE") {
                            $state.go("tooLongCours", {
                                cid: SessionService.getAuthData(),
                                id: SessionService.getAuthIdData(),
                                isKurs: true,
                                isTermin: false,
                                text: "LT_CANT_BOOK_TOO_LONG_COURSE"
                            });
                        }
                    } else if (error.data !== "LT_CANT_BOOK_NUTZUNGSRECHTE" && error.data !== "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("payment_member_already", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            message: error.data.message,
                            start: tempBooking.Start,
                            ende: tempBooking.Ende,
                            name: tempBooking.Artikel
                        });
                    }
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                }
            })
        }

        function setOnWaitlistBlockkurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                uid: userData.uid,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse
            };
            vm.spinner = true;
            BookingService.setOnWaitlistBlockkurs(tempBooking).then(function () {
                vm.spinner = false;
                unregisterEventHandler();
                $state.go('success_waitlist', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    isKurs: true,
                    isBlock: true
                });
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_TOO_LONG_COURSE") {
                        $state.go("tooLongCours", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_TOO_LONG_COURSE"
                        });
                    }
                }
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                } else if (error.status === 409) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true,
                        isTermin: false,
                        message: error.data.message,
                        start: tempBooking.Start,
                        ende: tempBooking.Ende,
                        name: tempBooking.Artikel
                    });

                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                }
            })
        }

        function setOnWaitlistKurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Terminart_Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: vm.kurs.Nr,
                Artikel: vm.kurs.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcesNrs,
                uid: userData.uid,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse
            };
            vm.spinner = true;
            BookingService.setOnWaitlistKurs(tempBooking).then(function () {
                unregisterEventHandler();
                vm.spinner = false;
                $state.go('success_waitlist', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    isKurs: true,
                    isTermin: false,
                    isBlock: vm.kurs.IstBlockkurs
                });
            }).catch(function (error) {
                vm.spinner = false;
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    if (error.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: vm.kurs.NutzungsrechteText
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("nutzungsrechte_member", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                        });
                    }
                    if(error.data === "LT_CANT_BOOK_TOO_LONG_COURSE") {
                        $state.go("tooLongCours", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            text: "LT_CANT_BOOK_TOO_LONG_COURSE"
                        });
                    } else if (error.data !== "LT_CANT_BOOK_NUTZUNGSRECHTE" && error.data !== "LT_CANT_BOOK_MITGLIEDSOPTION") {
                        $state.go("payment_member_already", {
                            cid: SessionService.getAuthData(),
                            id: SessionService.getAuthIdData(),
                            isKurs: true,
                            isTermin: false,
                            message: error.data.message,
                            start: tempBooking.Start,
                            ende: tempBooking.Ende,
                            name: tempBooking.Artikel
                        });
                    }
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: $stateParams.oid,
                        isKurs: true,
                        isTermin: false,
                        isBlock: vm.kurs.IstBlockkurs
                    });
                }
            })
        }

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.payNow = function (method) {
            if (method === 'pp') {
                if (vm.kurs.IstBlockkurs) {
                    bookPayPalBlockkurs();
                } else
                    bookPayPal();

            }
            if (method === 'six') {
                if (vm.kurs.IstBlockkurs) {
                    bookSixBlockkurs();
                } else
                    bookSix();
            }
            if (method === 'ls' || method === 'bar') {
                if (vm.kurs.IstBlockkurs) {
                    bookWithoutPaymentBlockkurs(method)
                } else
                    bookWithoutPayment(method);
            }
        }

    }]);